import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {storeGet, getStoreToken, getStoreRefreshToken, clearStoreTokens, STORE_LOGIN_PATH} from '../services/storeApi';

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  상점사(쇼핑몰) 화면 라우트 가드
 * ════════════════════════════════════════════════════════════════════════════════
 *  기존 비토리지 회원용 UserRouteAuth 와 동일한 역할이지만 검증 대상 토큰이 완전히 다르다.
 *  마운트 시 상점사 토큰을 확인하고, 실패하면 로그인 화면으로 보낸다.
 *
 *  ※ 반드시 storeGet 을 써야 한다. (raw axios 금지)
 *    - storeGet 은 X-STORE-TOKEN 부착 / AT 만료 시 RT 재발급 후 1회 재시도 /
 *      개발환경 동일출처 baseURL 을 모두 처리한다.
 *    - 예전에 여기서만 raw axios 로 직접 호출했다가, 개발환경에서 이 요청만
 *      절대주소로 나가 CORS 프리플라이트에 막히는 사고가 있었다.
 *      (nginx 허용헤더에 X-STORE-TOKEN 이 없어 교차출처에서 차단됨)
 *    - redirectOnFail:false 로 두어 이동은 이 가드가 직접 결정한다.
 * ════════════════════════════════════════════════════════════════════════════════
 */
const withStoreAuth = (WrappedComponent) => {
    return function StoreAuthGuard(props) {
        const navigate = useNavigate();
        const [checked, setChecked] = useState(false);

        useEffect(() => {
            let alive = true;

            const verify = async () => {
                if (!getStoreToken() && !getStoreRefreshToken()) {
                    navigate(STORE_LOGIN_PATH, {replace: true});
                    return;
                }

                try {
                    // 토큰 유효성은 내정보 조회로 확인한다(가장 가벼운 인증 엔드포인트).
                    // AT 가 만료됐으면 storeGet 내부에서 RT 재발급 후 한 번 재시도한다.
                    await storeGet('/store/myInfo', undefined, {redirectOnFail: false});
                    if (alive) setChecked(true);
                } catch (e) {
                    clearStoreTokens();
                    if (alive) navigate(STORE_LOGIN_PATH, {replace: true});
                }
            };

            verify();
            return () => {
                alive = false;
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        if (!checked) return null;
        return <WrappedComponent {...props} />;
    };
};

export default withStoreAuth;
